/** Display labels on the homepage → `/ciudades/:slug` (matches API city ids). */
export const HOME_REDESIGN_CITIES = [
  { label: 'Madrid', slug: 'madrid' },
  { label: 'Barcelona', slug: 'barcelona' },
  { label: 'Miami', slug: 'miami' },
  { label: 'Valencia', slug: 'valencia' },
  { label: 'Sevilla', slug: 'sevilla' },
  { label: 'Zaragoza', slug: 'zaragoza' },
  { label: 'Málaga', slug: 'malaga' },
  { label: 'Murcia', slug: 'murcia' },
  { label: 'Alicante', slug: 'alicante' },
  { label: 'Palma de Mallorca', slug: 'palma' },
  { label: 'Bilbao', slug: 'bilbao' },
  { label: 'Buenos Aires', slug: 'buenos-aires' },
  { label: 'Ciudad de México', slug: 'ciudad-de-mexico' },
  { label: 'Montevideo', slug: 'montevideo' },
  { label: 'New York', slug: 'new-york' },
  { label: 'Los Angeles', slug: 'los-angeles' },
] as const;

export const OG_IMAGE_URL = 'https://chisme.social/images/og/chisme-og.png';
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;
export const OG_IMAGE_ALT = 'Chisme — Haz planes y conoce mujeres como tú';
